import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { useEffect, useRef, useState } from "react";
import { loginRequest } from "./authConfig";
import LoadingSpinner from "./components/common/LoadingSpinner";

// eslint-disable-next-line react/prop-types
const AuthGate = ({ children }) => {
  const { instance, accounts, inProgress } = useMsal();
  const [hasTried, setHasTried] = useState(false);
  const hasRedirectedRef = useRef(false);

  useEffect(() => {
    if (inProgress !== "none") return;
    if (hasRedirectedRef.current) return;

    const account = instance.getActiveAccount() ?? accounts[0];
    if (account) {
      if (!instance.getActiveAccount()) instance.setActiveAccount(account);
      setHasTried(true);
      return;
    }

    // No cached account: go interactive once, then stop looping
    hasRedirectedRef.current = true;
    setHasTried(true);
    instance.loginRedirect(loginRequest);
  }, [instance, accounts, inProgress]);

  return (
    <>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>{!hasTried ? <LoadingSpinner /> : null}</UnauthenticatedTemplate>
    </>
  );
};

export default AuthGate;
